export default { sha: 'c23a560a1fce3643aa636606cd58acfeafc436f9', buildNumber: 'undefined' }
